import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { AemContextHub } from '../aemContextHub';
import { updateState } from './StateService';

var getInitialisedState = function getInitialisedState(storage, query) {
  var premiseId = initPremiseId(query.premiseId, storage.premiseId);
  var contractAccountId = initContractAccountId(storage, premiseId, query.contractAccountId);
  var selectedAddressId = initSelectedAddressId(query.selectedAddressId, storage.selectedAddressId);
  var selectedServiceId = initSelectedServiceId(storage, selectedAddressId, query.selectedServiceId);

  var newState = _objectSpread({}, storage, {
    contractAccountId: contractAccountId,
    premiseId: premiseId,
    selectedAddressId: selectedAddressId,
    selectedServiceId: selectedServiceId
  });

  var derivedContracts = updateState({}, newState);

  if (derivedContracts) {
    newState = _objectSpread({}, newState, {}, derivedContracts);
  }

  return newState;
};

var initPremiseId = function initPremiseId(fromQuery, fromStorage) {
  if (fromQuery) {
    return fromQuery;
  }

  var fromCookie = AemContextHub.getPremiseIdFromCookie();

  if (fromCookie) {
    return fromCookie;
  }

  if (fromStorage) {
    return fromStorage;
  }

  var fromHub = AemContextHub.getPremiseIdFromContextHub();

  if (fromHub) {
    return fromHub;
  }

  return;
};

var initSelectedAddressId = function initSelectedAddressId(fromQuery, fromStorage) {
  if (fromQuery) {
    return fromQuery;
  }

  if (fromStorage) {
    return fromStorage;
  }

  return;
};

var initSelectedServiceId = function initSelectedServiceId(storage, selectedAddressId, fromQuery) {
  if (fromQuery) {
    return fromQuery;
  }

  if (storage.selectedAddressId === selectedAddressId && storage.selectedServiceId) {
    return storage.selectedServiceId;
  }

  return;
};

var initContractAccountId = function initContractAccountId(storage, premiseId, fromQuery) {
  if (fromQuery) {
    return fromQuery;
  }

  if (storage.premiseId === premiseId && storage.contractAccountId) {
    return storage.contractAccountId;
  }

  if (premiseId) {
    var fromContextHub = AemContextHub.deriveContractAccountId(premiseId);

    if (fromContextHub) {
      return fromContextHub;
    }
  }

  return;
};

export { getInitialisedState, initPremiseId, initContractAccountId };